export const enum Tasks {
  runUp = '0',
  draw = '1',
  angle = '2',
  timing = '3',
}
